import { render, staticRenderFns } from "./itemDialog.vue?vue&type=template&id=a62654ba&scoped=true"
import script from "./itemDialog.vue?vue&type=script&lang=js"
export * from "./itemDialog.vue?vue&type=script&lang=js"
import style0 from "./itemDialog.vue?vue&type=style&index=0&id=a62654ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62654ba",
  null
  
)

export default component.exports